import React from 'react';

import {
  Container,
  Menu,
  Grid,
  Header,
  Segment,
  List,
  Image,
  Divider,
} from 'semantic-ui-react'

import Main from './Main';

import 'katex/dist/katex.min.css';
import 'semantic-ui-css/semantic.min.css';

var jsnx = require('jsnetworkx');

var test = () => {

  var G = new jsnx.Graph();

  G.addWeightedEdgesFrom([[2, 3, 10]]);
  G.addStar([3, 4, 5, 6], { weight: 5 });
  G.addStar([2, 1, 0, -1], { weight: 3 });


  jsnx.draw(G, {
    element: '#canvas',
    weighted: true,
    edgeStyle: {
      'stroke-width': 10
    }
  });

}

const App: React.FC = () => {

  return (
    <div className="App">
      <div style={{ "padding": "30px" }}>
        <Menu fixed='top' inverted>
          <Container>
            <Menu.Item as='a' href='/'>Home</Menu.Item>
            {/*<Menu.Item as='a' href='/ml'>ML</Menu.Item>*/}
            {/*<Menu.Item as='a' href='/qc'>QC</Menu.Item>*/}
            {/*<Menu.Item as='a' href='/article'>Article</Menu.Item>*/}
            <Menu.Item as='a' href='/about'>About</Menu.Item>
          </Container>
        </Menu>
      </div>

      <Main />

      {/* {test()} */}

      <Segment inverted style={{ margin: '5em 0em 0em', padding: '5em 0em' }} vertical>
        <Container textAlign='center'>
          <List horizontal inverted divided link size='small'>
            <List.Item as='a' href='/'>
              Home
            </List.Item>
            <List.Item as='a' href='https://github.com/hiroshi0530/'>
              Github
            </List.Item>
          </List>
        </Container>
      </Segment>

    </div>
  );
}

export default App;
